import { parse as fnsParse, format as fnsFormat } from 'date-fns';

export const capitalize = (str: string | null) => {
  if (!str) return '';

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatDate = (date: Date | string | number) => {
  return new Date(date).toLocaleDateString();
};

export const formatShortCryptoAddress = (address: string | null) => {
  if (!address) return 'N/A';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const formatFullNameToInitials = (fullName: string | null) => {
  if (!fullName) return '';
  const names = fullName.split(' ');
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return `${names[0].charAt(0).toUpperCase()}.${names[1]
    .charAt(0)
    .toUpperCase()}.`;
};

export const formatMoneyTotal = (value: number | string) => {
  return Number(value).toFixed(2);
};
